/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_TitleInputs */



/**
* | output |
* | --- |
* | "Merge Event Group" |
*
* @param {Merge_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_title = /** @type {((inputs?: Merge_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner le groupe d'evenements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführungsereignisgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа мероприятий по слиянию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループを結合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह को मर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos de Fusão")
	return /** @type {LocalizedString} */ ("Merge Event Group")
});